"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarMenuItem = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ToolbarItem_1 = require("../ToolbarItem");
const FixedColumn_1 = require("../../../3-list-item/FixedColumn");
const Arrow_1 = tslib_1.__importDefault(require("../../../icons/interactive/Arrow"));
const ToolbarMenuPopup_1 = require("./ToolbarMenuPopup");
const context_1 = require("./context");
const ToolbarMenuItemTerminal_1 = require("./ToolbarMenuItemTerminal");
const useBehaviorSubject_1 = require("../../../hooks/useBehaviorSubject");
const useSyncStore_1 = require("../../../hooks/useSyncStore");
const Iconista_1 = require("../../../icons/Iconista");
const ToolbarMenuItem = (props) => {
    const { item, disabled } = props;
    const arrow = React.useRef(null);
    const toolbar = (0, context_1.useToolbarMenu)();
    const openPanel = toolbar?.openPanel;
    (0, useBehaviorSubject_1.useBehaviorSubjectOpt)(openPanel?.selected$);
    const active = !!(0, useSyncStore_1.useSyncStoreOpt)(item.active);
    const isTerminal = !item.pane && !item.raw && (!item.children || item.children.length === 0);
    const id = item.id ?? item.name;
    if (isTerminal) {
        return React.createElement(ToolbarMenuItemTerminal_1.ToolbarMenuItemTerminal, { ...props });
    }
    const selected = openPanel?.isSelected(id) ?? false;
    const icon = item.icon?.() ?? React.createElement(Iconista_1.Iconista, { set: 'elastic', icon: 'empty', width: 16, height: 16 });
    const split = item.split;
    if (split) {
        return (React.createElement(React.Fragment, null,
            React.createElement(ToolbarItem_1.ToolbarItem, { compact: true, disabled: disabled, selected: active, bdradR: 2, onClick: disabled ? void 0 : item.onSelect, tooltip: {
                    shortcut: item.keys?.join(''),
                    renderTooltip: () => item.name ?? item.id ?? '',
                } }, icon),
            React.createElement("div", { style: { width: 1 } }),
            React.createElement(ToolbarMenuPopup_1.ToolbarMenuPopup, { header: !item.noHeader, open: selected, item: item },
                React.createElement(ToolbarItem_1.ToolbarItem, { narrow: true, compact: true, disabled: disabled, selected: selected, bdradL: 2, onMouseEnter: disabled ? void 0 : () => openPanel?.onMouseMove(id), onMouseMove: disabled ? void 0 : () => openPanel?.onMouseMove(id), onMouseLeave: disabled ? void 0 : openPanel?.onMouseLeave, onClick: disabled ? void 0 : () => openPanel?.onClick(id), tooltip: {
                        renderTooltip: () => split,
                    } },
                    React.createElement("div", { ref: arrow, style: { display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 -1px' } },
                        React.createElement(Arrow_1.default, { width: 16, height: 16, direction: selected
                                ? (arrow.current?.getBoundingClientRect()?.top ?? 0) * 2 + 16 >= window.innerHeight
                                    ? 'u'
                                    : 'd'
                                : 'r' }))))));
    }
    return (React.createElement(ToolbarMenuPopup_1.ToolbarMenuPopup, { header: !item.noHeader, open: selected, item: item },
        React.createElement(ToolbarItem_1.ToolbarItem, { ...(item.pane ? {} : { width: 'auto' }), compact: true, selected: selected || active, onMouseEnter: disabled ? void 0 : () => openPanel?.onMouseMove(id), onMouseMove: disabled ? void 0 : () => openPanel?.onMouseMove(id), onMouseLeave: disabled ? void 0 : openPanel?.onMouseLeave, onClick: disabled ? void 0 : (event) => toolbar?.execute(item, event), disabled: disabled, tooltip: {
                shortcut: item.keys?.join(''),
                renderTooltip: () => item.name ?? item.id ?? '',
            } }, item.pane ? ((item.icon?.() ?? React.createElement(Iconista_1.Iconista, { set: 'elastic', icon: 'empty', width: 16, height: 16 }))) : (React.createElement(FixedColumn_1.FixedColumn, { right: 16, style: { alignItems: 'center' } },
            item.icon?.() ?? React.createElement(Iconista_1.Iconista, { set: 'elastic', icon: 'empty', width: 16, height: 16 }),
            React.createElement("div", { ref: arrow, style: { marginRight: -2, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                React.createElement(Arrow_1.default, { direction: selected
                        ? (arrow.current?.getBoundingClientRect()?.top ?? 0) * 2 + 16 >= window.innerHeight
                            ? 'u'
                            : 'd'
                        : 'r' })))))));
};
exports.ToolbarMenuItem = ToolbarMenuItem;
